<!-- 1:1 aspect ratio -->
<div class="embed-responsive embed-responsive-1by1" *ngIf="showDoc">
  <iframe class="embed-responsive-item" [attr.srcDoc]="errorDoc"
    >Unexpected Server Error</iframe
  >
</div>
